import React, { useEffect, useState } from 'react';
import { Modal, Popconfirm, message, Spin, Skeleton, Image, PaginationProps, Pagination, Tooltip } from 'components/shared/AntComponent';
import { Button, Checkbox, Input, Form, Select, Radio } from 'components/shared/FormComponent';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { DownCircleFilled, CloseCircleOutlined, DownSquareOutlined, SearchOutlined, LoadingOutlined } from 'components/shared/AntIcons';
import { getQuestionInfo, getSubjInfo } from 'services/store/actions/questionbankAction';
import { addQuestionPaper, getEachQuestionPaper, getITQuestionDetailInfo, getQuestionDetailInfo } from 'services/store/actions/questionPaperAction';

interface DataType {
    options: any;
    id: any;
    sno: number;
    Mdquestions_name: string;
    answer: string;
    level_of_difficulty: string;
    created_on: string;
}

const UpdateQuestionPaper: React.FC = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const history = useNavigate();
    const [form] = Form.useForm();
    const [selectAll, setSelectAll] = useState(false);
    const { questionbankData, loading, success2, error2, quesDetailInfo, loading5, subjectInfo, loading6, } = useSelector((state: any) => state.questionbank);
    const { quesPaperInfo, success1, loading1, error1, loading3, loading6: paperLoading, quespaprInfo, loading9, itQuesInfo } = useSelector((state: any) => state.questionpaper);
    const [data, setData] = useState([]);
    const itData = !loading9 && itQuesInfo ? itQuesInfo?.data : [];
    const itTotalPage = !loading9 && itQuesInfo ? itQuesInfo?.total_records : 0;
    // const [itData,setItData] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [selectedLevel, setSelectedLevel] = useState('all');
    const [paperTitle, setPaperTitle] = useState('');
    const [modalTitle, setModalTitle] = useState('Add Aptitude');
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [searchVal, setSearchVal] = useState('');
    const [itPageIndex, setItPageIndex] = useState(1);
    const [itPageSize, setItPageSize] = useState(10);
    const [activeTab, setActiveTab]: any = useState(null);
    const [selectedModalData, setSelectedModalData]: any = useState([]);
    const [selectedModalData1, setSelectedModalData1]: any = useState([]);
    const [expandVal, setExpandVal]: any = useState([]);
    const [selectedVal, setSelectedVal]: any = useState([]);
    const [selectedVal1, setSelectedVal1]: any = useState([]);
    const [selectedMark, setSelectedMark]: any = useState(0);
    const [selectedMark1, setSelectedMark1]: any = useState(0);
    const [selectedDegree, setSelectedDegree] = useState('');
    const [selectedSubj, setSelectedSubj]: any = useState('');
    const [selectedSubj1, setSelectedSubj1]: any = useState('');
    // const [subjOptions1,setSubjOptions1]:any=useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [preferredField, setPreferredField]: any = useState(null);
    // const apiUrl = window.location.href.startsWith('https://kovina-a8h7dcdshdddhmcy.southindia-01.azurewebsites.net') ? "https://kovina-api-gba4f4drejguf6dy.southindia-01.azurewebsites.net/api/"
    //     : window.location.href.startsWith('https://qa.kovina.com') ? "https://qa-api.kovina.com/api/" : "https://dev-api-v1.kovina.com/api/";
    //right side card
    const [count, setCount] = useState(0);
    let counter = 0,
        counter1 = 0;

    const [isEmptyVal, setIsEmptyVal] = useState(false);
    //modal and success
    const [modalData, setModalData]: any = useState([]);
    const [modalData1, setModalData1]: any = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success1 : false;
    const [showErrMsg, setShowErrMsg] = useState(false);
    const errMsg = showErrMsg ? (error1 ? true : false) : false;
    const [deptOptions, setDeptOptions] = useState([]);
    const [dept, setDept] = useState('');
    const [fieldType, setFieldType] = useState('core');
    const [subjOptions, setSubjOptions]: any = useState([]);
    useEffect(() => {
        if (quesDetailInfo?.data) {
            const departmentOptions = !loading5 && quesDetailInfo?.data?.departments?.filter((item: any) => item != null && item.toString().trim() !== '' && item != "general")
                ?.map((item: any) => {
                    return {
                        value: item,
                        label: item,
                    }
                });
            // setDeptOptions(departmentOptions);

            if (preferredField && preferredField == "it" && departmentOptions) {
                // If preferredField is "it", filter only "programming"
                const filteredDepartmentOptions = !loading5 ? departmentOptions?.filter((option: any) => option.value.toLowerCase() === "programming") : [];
                setDeptOptions(filteredDepartmentOptions);
            } else if (preferredField && preferredField == "core|it") {
                const filteredDepartmentOptions = !loading5 ? departmentOptions?.filter((option: any) => option.value.toLowerCase() !== "programming") : [];
                setDeptOptions(filteredDepartmentOptions);
            } else {
                setDeptOptions(departmentOptions);
            }
        }
    }, [quesDetailInfo, preferredField]);

    useEffect(() => {
        if (subjectInfo?.data) {
            let subjectOptions: any[] = [];

            if (!loading6 && Array.isArray(subjectInfo.data.subjects)) {
                subjectOptions = subjectInfo.data.subjects
                    .filter((item: any) => item !== null)
                    .map((item: any) => ({
                        value: item,
                        label: item
                    }));
            }

            // Always add "All" if we have at least one valid option
            if (subjectOptions.length > 0) {
                subjectOptions.push({ value: '', label: 'All' });
            }

            setSubjOptions(subjectOptions);
        }
    }, [subjectInfo]);

    function getPaperDetails(id: any, dept: string, subj: string, diff: string, page: number, size: number, search: string) {
        const inputJson = {
            "Input": {
                "mdtechnology_hints": "all",
                "difficulty_levels": diff || "hard",
                "question_categories": id?.toString() || "",
                "subjects": subj || "all",
                "departments": dept || "cse",
                "bloom_levels": "all"
            },

            "DataFinder": {
                "pagesize": size || 10,
                "currentpage": page || 1,
                "sortbycolumn": "",
                "sortby": "asc",
                "searchdata": search || ""
            }
        }
        dispatch(getQuestionDetailInfo(inputJson) as any);
    }
    function getITPaperDetails(id: any, dept: string, subj: string, diff: string, page: number, size: number, search: string) {
        const inputJson = {
            "Input": {
                "mdtechnology_hints": "all",
                "difficulty_levels": diff || "hard",
                "question_categories": id?.toString() || "",
                "subjects": subj || "all",
                "departments": dept || "programming",
                "bloom_levels": "all"
            },

            "DataFinder": {
                "pagesize": size || 10,
                "currentpage": page || 1,
                "sortbycolumn": "",
                "sortby": "asc",
                "searchdata": search || ""
            }
        }
        dispatch(getITQuestionDetailInfo(inputJson) as any);
    }

    useEffect(() => {
        if (location.state.id === 0) {
            setCount(0);
            if (quespaprInfo) {
                setCount(quespaprInfo?.total_records);
                setTotalRecord(quespaprInfo?.total_records);
            }
        } else {
            if (quesPaperInfo?.question_listids) {
                setCount(0);
                setData(quesPaperInfo?.question_listids);
                const ids = quesPaperInfo?.question_listids
                    .filter((item: any) => item.id)  // Filter items that have an `id`
                    .map((item: any) => item.id);     // Map to extract just the `id` values
                setSelectedVal(ids);

                setSelectedMark(quesPaperInfo?.question_info?.total_marks);
                setPaperTitle(quesPaperInfo?.question_info?.title);
                setCount(quesPaperInfo?.question_listids?.length);
            }
            if (quesPaperInfo?.question_info?.category_type == 3 || quesPaperInfo?.question_info?.category_type == "type_3") {
                setActiveTab(3);
                form.setFieldsValue({
                    "questionCategory": "all",
                    "department": quesPaperInfo?.question_info?.question_paper_subject,
                    "examTitle": quesPaperInfo?.question_info?.title,
                    "preferredField":quesPaperInfo?.question_info?.preferred_field
                });
                setPreferredField(quesPaperInfo?.question_info?.preferred_field);
                getQuestionDetails(quesPaperInfo?.question_info?.question_paper_subject);
                setDept(quesPaperInfo?.question_info?.question_paper_subject);
            } else {
                form.setFieldsValue({
                    "questionCategory": "general",
                    "department": "",
                    "examTitle": quesPaperInfo?.question_info?.title,
                    "preferredField":null
                });
                getQuestionDetails("general");
                getSubjectDetails("general");
                setDept(quesPaperInfo?.question_info?.question_paper_subject);
                setActiveTab(1);
                setPreferredField(null);
            }
            setSelectedMark(quesPaperInfo?.question_info?.total_score);
        }
        if (quespaprInfo) {
            setModalData(quespaprInfo?.data || []);
            setTotalRecord(quespaprInfo?.total_records);

        }
        if (itQuesInfo) {
            setModalData1(itQuesInfo?.data || []);
        }
    }, [quesPaperInfo, location?.state, quespaprInfo, itQuesInfo]);

    const getSubjectDetails = (dept: string) => {
        const inputJson = {
            "mdtechnology_hints": "all",
            "difficulty_levels": "all",
            "question_categories": "all",
            "subjects": "all",
            "departments": dept || "all",
            "bloom_levels": "all"
        }
        dispatch(getSubjInfo(inputJson) as any);
    }
    useEffect(() => {
        if (location.state.id !== 0) {
            setIsEdit(false);
            getquesPaper(location.state?.id);
        } else {
            setData([]);
            setSelectedMark(0);
            setSelectedVal([]);
            form.resetFields();
            setDept('');
            setActiveTab(null);
            setSelectedLevel('all');
        }
    }, [location.state]);

    const handleBack = () => {
        history('/question-paper');
    };

    const openModal = () => {
        if (activeTab == 1) {
            setModalTitle('Add Aptitude Questions');
        } else if (activeTab == 2) {
            setModalTitle('Add Analytics Questions');
        } else {
            setModalTitle('Add Technical Questions');
        }
        setIsModalOpen(true);
        setSelectedVal1(selectedVal);
        setSelectedMark1(selectedMark);
        setSearchVal('');
        setItPageIndex(1);
        setItPageSize(10);
        setSelectedLevel('all');
        setPageIndex(1);
        setSearchVal('');
        setSelectedSubj('');
        setPageSize(10);
        if (preferredField === 'core|it') {
            setFieldType('core');
            getITPaperDetails(activeTab, "programming", "all", 'all', 1, 10, '');
        }
        getPaperDetails(activeTab, dept, 'all', 'all', 1, 10, '');
    };

    const handleExpand = (id: string) => {
        let myArray = expandVal;
        const valueExists = myArray.includes(id);
        if (!valueExists) {
            myArray = [...myArray, id];
        } else {
            if (myArray.includes(id)) {
                myArray = expandVal.filter((item: any) => item != id);
            }
        }
        setExpandVal(myArray);
    };
  
    useEffect(() => {
        if (successmsg) {
            if (location.state.id === 0) {
                message.success('Question paper created successfully');
                setPaperTitle('');
                setSelectedVal([]);
                setSearchVal('');
                setSelectedDegree('');
                setPageIndex(1);
                setPageSize(10);
                setSelectedMark(0);
                setDept('');
                setActiveTab(null);
                setSelectedLevel('all');
                // getAptitudeQuestions(1, selectedLevel, '', 10, 1, '');
                setIsEmptyVal(false);
                form.resetFields();
                setData([]);
            } else {
                message.success('Question paper updated successfully');
            }
            setShowSuccessmsg(false);
        }
        if (errMsg) {
            if (error1?.data) {
                message.error(error1?.data);
            } else {
                message.error("Question paper couldn't be added");
            }
            setShowErrMsg(false);
        }
    }, [successmsg, errMsg]);

    const submitPaper = async () => {
        const value = await form.validateFields();
        const inputJson = {
            questionspaperid: location.state?.id || 0,
            title: value.examTitle || "",
            total_question: selectedVal?.length?.toString() || 0,
            question_paper_subject: dept || 'all',
            duration: "",
            question_listids: selectedVal?.toString() || '',
            total_score: selectedMark || null,
            category_type: activeTab == 1 ? 1 : 3,
            "preferred_field": value?.preferredField || ""
        };

        dispatch(addQuestionPaper(inputJson) as any);
        setShowSuccessmsg(true);
        setShowErrMsg(true);

    };

    const getquesPaper = (id: any) => {
        dispatch(getEachQuestionPaper(id) as any);
    };

    const removeQues = (id: number) => {
        let myArray = selectedVal;
        if (myArray.includes(id)) {
            myArray = selectedVal.filter((item: any) => item != id);
        }
        setSelectedVal([]);
        setSelectedVal(myArray);
        let myArray1 = data;
        const valueExists = myArray1?.some((item: any) => item.id === id);
        const removedQues: any = myArray1?.find((item: any) => item.id === id);
        if (valueExists) {
            myArray1 = myArray1.filter((item: any) => item?.id != id);  // Remove the id if unchecked
            setSelectedMark((prev: number) => prev - (removedQues?.marks || 1));
        }
        setData(myArray1);
        setSelectedVal1(myArray);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setPageIndex(1);
        setPageSize(1);
        setSearchVal('');
        setSelectedMark(selectedMark1);

        setSelectedVal(selectedVal1);

        // Handle data update: add selected questions to 'data' and remove unselected ones
        const updatedData = [...data];

        // Iterate through current data and remove any question not in selectedVal
        const newData: any = updatedData.filter((item: any) => selectedVal1.includes(item.id));

        // Iterate through unique selected questions and add them to data if not already there
        selectedVal1.forEach((id: any) => {
            const isAlreadyInData = newData.some((item: any) => item.id === id);
            if (!isAlreadyInData) {
                // Find the question details based on the ID and add to data
                const question = selectedModalData.find((item: any) => item.id === id) || null;
                if (question) {
                    newData.push(question); // Add question to newData if it's not already there
                }
            }
        });
        // Set updated data array
        setData(newData);
    };

    const addQuestionData = () => {
        handleCancel();
        setSelectedMark(selectedMark1);
        setSelectedMark1(0);
        setSelectedVal([]);
        const uniqueIds = [...new Set(selectedVal1)];
        setSelectedVal(selectedVal1);
        const updatedData = [...data, ...itData];
        const newData: any = updatedData.filter((item: any) => uniqueIds.includes(item.id));
        uniqueIds.forEach((id: any) => {
            const isAlreadyInData = newData.some((item: any) => item.id === id);
            if (!isAlreadyInData) {
                const question = selectedModalData.find((item: any) => item.id === id) || null;
                if (question) {
                    newData.push(question); // Add question to newData if it's not already there
                }
            }
        });
        setData(newData);
        setSelectedVal1([]);
        setModalData([]);
        setModalData1([]);
    };

    const handleCheckedModal = (id: number, val: any) => (e: any) => {
        const checked = e.target.checked;
        let sum = 0;
        if (checked) {
            if (fieldType == "it") {
                if (!selectedModalData1?.some((item: any) => item.id === val.id)) {
                    setSelectedModalData1((prevData: any) => [...prevData, val]);
                }
                sum = selectedMark1 + Number(val?.mark || 1) || 1
            } else {
                // Check if the value is already in selectedModalData before adding
                if (!selectedModalData?.some((item: any) => item.id === val.id)) {
                    setSelectedModalData((prevData: any) => [...prevData, val]);
                }
                sum = selectedMark1 + Number(val?.mark || 1) || 1
            }

        } else {
            if (fieldType == "it") {
                setSelectedModalData1((prevData: any) => prevData.filter((item: any) => item.id !== val.id));
                sum = selectedMark1 - Number(val?.mark || 1) || 1
            } else {
                // Remove the item from selectedModalData when unchecked
                setSelectedModalData((prevData: any) => prevData.filter((item: any) => item.id !== val.id));
                sum = selectedMark1 - Number(val?.mark || 1) || 1
            }
        }

        setSelectedMark1(sum);

        let myArray = selectedVal1;
        const valueExists = myArray.includes(id);

        if (checked && !valueExists) {
            myArray = [...myArray, id];  // Add the id if checked and not already in the array
        } else {
            if (myArray.includes(id)) {
                myArray = selectedVal1.filter((item: any) => item != id);  // Remove the id if unchecked
            }
        }

        // Update selectedVal1 state with the modified array
        setSelectedVal1(myArray);
    };

    const filteredData = data?.filter((item: any) => item.questions_category == activeTab) || [];

    const handleChangePagination = (page: number, pageSize: number) => {

        setPageIndex(page);
        setPageSize(pageSize);
        getPaperDetails(activeTab, dept, selectedSubj, selectedLevel, page, pageSize, searchVal);
        // getAptitudeQuestions(activeTab, selectedLevel, searchVal, pageSize, page, dept);
    }
    const handlePageSizeChange: PaginationProps['onShowSizeChange'] = (current, pageSize) => {

        console.log("")

    }
    const handleChangePagination1 = (page: number, pageSize: number) => {

        setItPageIndex(page);
        setItPageSize(pageSize);
        getITPaperDetails(activeTab, "programming", selectedSubj, selectedLevel, page, pageSize, searchVal);
        // getAptitudeQuestions(activeTab, selectedLevel, searchVal, pageSize, page, dept);
    }
    const handlePageSizeChange1: PaginationProps['onShowSizeChange'] = (current, pageSize) => {

        console.log("")

    }

    const handleSearch = (e: any) => {
        if (e.key === 'Enter') {
            setSearchVal(e.target.value);
            setPageIndex(1);
            // getAptitudeQuestions(activeTab, selectedLevel, e.target.value, pageSize, 1, dept);
            getPaperDetails(activeTab, dept, selectedSubj, selectedLevel, 1, 10, e.target.value);
        }
    };
    const resetSearch = (e: any) => {
        if (e.key === 'Backspace' && !e.target.value) {
            setSearchVal(e.target.value);
            setPageIndex(1);
            getPaperDetails(activeTab, dept, selectedSubj, selectedLevel, 1, 10, e.target.value);
            // getAptitudeQuestions(activeTab, selectedLevel, e.target.value, pageSize, 1, dept);
        }
    };

    // function getDegrees() {
    //     dispatch(getDegreeList() as any);
    // }
    const getQuestionDetails = (dept: string) => {
        const inputJson = {
            "mdtechnology_hints": "all",
            "difficulty_levels": "all",
            "question_categories": "all",
            "subjects": "all",
            "departments": dept,
            "bloom_levels": "all"
        }
        dispatch(getQuestionInfo(inputJson) as any);
    }

    // useEffect(() => {
    //     getDegrees();
    // }, []);

    const categoryOptions = [
        {
            value: "general",
            label: "Aptitude"
        },
        {
            value: "all",
            label: "Technical"
        }
    ];

    const handleCatChange = (e: any) => {
        getQuestionDetails(e);
        setSubjOptions([]);
        form.setFieldsValue({ 'department': '', 'preferredField': '' });
        setActiveTab(e == 'general' ? 1 : 3);
        setSelectedVal([]);
        setData([]);
        setPreferredField('');
        setSelectedMark(0);
        if (e == "general") {
            getSubjectDetails(e);
            setDeptOptions([]);
            setDept('all');
        } else {
            setDept('');
        }
    }

    const handleDeptChange = (e: any) => {
        setSubjOptions([]);
        getSubjectDetails(e);
        setDept(e);
    }

    const handleChangeLevel = (e: any) => {
        setSelectedLevel(e);
        setPageIndex(1);
        // getAptitudeQuestions(activeTab, e, searchVal, pageSize, 1, dept);
        getPaperDetails(activeTab, dept, selectedSubj, e, 1, pageSize, searchVal);
    }
    const handleChangeSubj = (e: any) => {
        setSelectedSubj(e);
        setPageIndex(1);
        if (fieldType == "it") {
            getITPaperDetails(activeTab, "programming", e, selectedLevel, 1, pageSize, searchVal);
        } else {
            getPaperDetails(activeTab, dept, e, selectedLevel, 1, pageSize, searchVal);
        }

    }
    const handleSelectAll = (checked: boolean) => {
        setSelectAll(checked);

        if (checked) {
            // Add all items from the current page that aren't already selected
            if (fieldType == "it") {
                const newItems = modalData1.filter(
                    (item: any) => !selectedModalData1.some((sel: any) => sel.id === item.id)
                );

                // Add these items to selectedModalData
                setSelectedModalData1((prev: any) => [...prev, ...newItems]);

                // Add IDs to selectedVal1
                const newIds = modalData1
                    .map((item: any) => item.id)
                    .filter((id: number) => !selectedVal1.includes(id));
                setSelectedVal1((prev: any) => [...prev, ...newIds]);

                // Update total marks
                const sumMarks = newItems.reduce(
                    (sum: any, item: any) => sum + Number(item?.mark || 1),
                    selectedMark1
                );
                setSelectedMark1(sumMarks);
            } else {
                const newItems = modalData.filter(
                    (item: any) => !selectedModalData.some((sel: any) => sel.id === item.id)
                );

                // Add these items to selectedModalData
                setSelectedModalData((prev: any) => [...prev, ...newItems]);

                // Add IDs to selectedVal1
                const newIds = modalData
                    .map((item: any) => item.id)
                    .filter((id: number) => !selectedVal1.includes(id));
                setSelectedVal1((prev: any) => [...prev, ...newIds]);

                // Update total marks
                const sumMarks = newItems.reduce(
                    (sum: any, item: any) => sum + Number(item?.mark || 1),
                    selectedMark1
                );
                setSelectedMark1(sumMarks);
            }

        } else {
            if (fieldType === 'it') {
                // Remove only current page's items
                const currentIds = modalData1.map((item: any) => item.id);

                // Remove those objects from selectedModalData
                setSelectedModalData1((prev: any) =>
                    prev.filter((item: any) => !currentIds.includes(item.id))
                );

                // Remove IDs from selectedVal1
                setSelectedVal1((prev: any) =>
                    prev.filter((id: number) => !currentIds.includes(id))
                );

                // Subtract marks for items on this page
                const sumMarks = modalData1.reduce(
                    (sum: any, item: any) => sum - (selectedModalData1.some((sel: any) => sel.id === item.id) ? Number(item?.mark || 1) : 0),
                    selectedMark1
                );
                setSelectedMark1(sumMarks >= 0 ? sumMarks : 0); // prevent negative totals
            } else {
                // Remove only current page's items
                const currentIds = modalData.map((item: any) => item.id);

                // Remove those objects from selectedModalData
                setSelectedModalData((prev: any) =>
                    prev.filter((item: any) => !currentIds.includes(item.id))
                );

                // Remove IDs from selectedVal1
                setSelectedVal1((prev: any) =>
                    prev.filter((id: number) => !currentIds.includes(id))
                );

                // Subtract marks for items on this page
                const sumMarks = modalData.reduce(
                    (sum: any, item: any) => sum - (selectedModalData.some((sel: any) => sel.id === item.id) ? Number(item?.mark || 1) : 0),
                    selectedMark1
                );
                setSelectedMark1(sumMarks >= 0 ? sumMarks : 0); // prevent negative totals
            }

        }
    };

    const handleField = (e: any) => {
        setPreferredField(e.target.value);
        setDept('');

        form.setFieldValue('department', '');
    }


    const handleFieldChange = (e: any) => {
        setFieldType(e.target.value);
        setSelectedLevel("all");
        setSearchVal('');
        setSelectedSubj('');
        if (e.target.value == "it") {
            getSubjectDetails('programming');
        } else {
            getSubjectDetails(dept);
        }
    }

    return (
        <div className="add-question-paper my-3 mx-2">
            <div className="border-0 header-card rounded-0">
                <div className="row m-0">
                    <div className="col-md-5 ps-0 my-auto form-card text-start">
                        <h5 className="ps-0 my-auto text-secondary fw-bold">{location.state.id !== 0 ? 'Update Question Paper' : 'Add Question Paper'} </h5>
                    </div>
                    <Button type="primary" className="my-auto col-auto ms-auto px-4 rounded-0 btn-back" onClick={handleBack}>
                        Back
                    </Button>
                </div>
            </div>
            <Spin spinning={loading3}>
                <div className="my-2 row mx-0">
                    <div className="col-md-12 bg-white question-selection p-3">
                        <div className="row mx-0">
                            <Form form={form} layout="vertical" className="px-0">
                                <div className='row mx-0 px-0'>
                                    <Form.Item label="Paper Title" name="examTitle" className="col ps-0"
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Question Category" name="questionCategory" className="col-md-3 px-0"
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Select options={categoryOptions} onChange={handleCatChange} />
                                    </Form.Item>
                                    {activeTab == 3 ?
                                        <Form.Item label="Preferred Field" name="preferredField" className="col-md-2 px-3"
                                            rules={[{ required: true, message: "This field is required" }]}>
                                            <Radio.Group
                                                onChange={handleField}
                                                options={[
                                                    { value: 'core', label: 'Core' },
                                                    { value: 'it', label: 'IT' },
                                                    { value: 'core|it', label: 'Core/IT' },
                                                ]}
                                            />
                                        </Form.Item> : ""}
                                    {activeTab == 3 ?
                                        <Form.Item label="Specialisation" name="department" className="col-md-3 pe-0"
                                            rules={[{ required: true, message: "This field is required" }]}>
                                            <Select options={deptOptions} onChange={handleDeptChange}
                                                notFoundContent={
                                                    <div className="text-center p-4">
                                                        {loading5 ? (
                                                            <span>
                                                                <LoadingOutlined />
                                                                Loading...
                                                            </span>
                                                        ) : (
                                                            <span>{activeTab !== null ? "No department found" : "Select department"}</span>
                                                        )}
                                                    </div>
                                                }
                                                filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())} />
                                        </Form.Item> : ""}
                                    {/* <Form.Item label="Subject" name="subject" className="col pe-0"
                                        rules={[{ required: true, message: "This field is required" }]}>
                                        <Select options={subjOptions}
                                            notFoundContent={
                                                <div className="text-center p-4">
                                                    {loading6 ? (
                                                        <span>
                                                            <LoadingOutlined />
                                                            Loading...
                                                        </span>
                                                    ) : (
                                                        <span>{activeTab !== null ? "No subject found" : "Select department"}</span>
                                                    )}
                                                </div>
                                            }
                                            filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())} />
                                    </Form.Item> */}
                                </div>
                            </Form>
                        </div>

                        <div className="row m-0 text-start question-radio ">
                            <h6 className="text-start col my-auto ps-0">Associate Questions</h6>
                            <div className="col-auto ms-auto my-auto pe-0">
                                <Tooltip title={activeTab == null ? 'Select Question category to add questions' : dept == '' ? 'Select department to add questions' :
                                    activeTab == 3 && preferredField == '' ? 'Select preferred field to add questions' : ''}>
                                    <Button type="primary" onClick={() => openModal()} disabled={activeTab == 1 ? false : dept == '' ? true : activeTab == 3 && preferredField == '' ? true : false}>
                                        + Add Questions
                                    </Button>
                                </Tooltip>
                            </div>
                            {/* ) : (
                                ''
                            )} */}
                        </div>
                        {/* {location.state.id !== 0 ? ( */}
                        <div className="px-2 py-3 mb-3 mt-1 question-list-cont custom-scrollbar border bg-light">
                            {loading3 ? (
                                <Skeleton active />
                            ) : (
                                <div className="row mx-0">
                                    {data.length === 0 ? (
                                        <div className="text-center text-muted h-100 w-100 py-3">
                                            <h6 className="mt-5 pt-5">No Questions Associated</h6>
                                        </div>
                                    ) : (
                                        data.map((item: any, index: number) => {
                                            counter++;
                                            return (
                                                <div key={index} className="col-md-6 d-flex mb-2 rounded">
                                                    <div className="question-cntr bg-white w-100">
                                                        <div className="bg-lightPrimary d-flex p-2 align-items-start">
                                                            <div className="">
                                                                <span className="text-secondary fw-bold pe-3">({counter})</span>
                                                            </div>
                                                            <div className="pe-4 borde pb-2">
                                                                <span className="author-name text-gray fw-bold">{item.Mdquestions_name}</span>
                                                                {item.question_image ? <Image src={window.origin+"/api" + item.question_image} height={50} /> : ""}
                                                                <div className="me-2">
                                                                    <div className="bg-primary fs-12 text-white rounded px-2 me-2 py-1 col-auto d-inline-block my-2">
                                                                        {item.subject}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="ms-auto d-flex qus-opr align-items-start justify-content-center">
                                                                <div className=" my-auto me-1 ">
                                                                    <DownCircleFilled
                                                                        className={`fs-14 ${item.level_of_difficulty == 'easy' ? 'text-success bg-success' : item.level_of_difficulty == 'medium' ? 'text-warning bg-warning' : 'text-danger bg-danger'} rounded-circle`}
                                                                    />
                                                                </div>
                                                                <Popconfirm
                                                                    title="Remove Question"
                                                                    description="Are you sure to remove this question?"
                                                                    onConfirm={() => removeQues(item.id)}
                                                                    okText="Yes"
                                                                    cancelText="No"
                                                                >
                                                                    <Tooltip title="Remove Question">
                                                                        <span className="my-auto fs-16 pointer">
                                                                            <CloseCircleOutlined className="text-danger" />
                                                                        </span>
                                                                    </Tooltip>
                                                                </Popconfirm>
                                                                <div className="text-primary ms-1 mb-0 mt-1 pointer my-auto" onClick={() => handleExpand(item.id)}>
                                                                    {expandVal?.includes(item.id) ? (
                                                                        <DownSquareOutlined className="fs-17" rotate={-90} />
                                                                    ) : (
                                                                        <DownSquareOutlined className="fs-17" />
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={`p-2 d-flex question-contn bg- ${expandVal?.includes(item.id) ? 'incheight' : ''}`}>
                                                            <div className="ps-2 pe-4 w-100 text-start">
                                                                <div className="row mx-3 my-1">
                                                                    {item.Mdquestions_type === "inputfield" || item.Mdquestions_type == "input" ? <div className="fw-bold fs-15">
                                                                        <span className="text-success">
                                                                            {item.answer}
                                                                        </span>
                                                                    </div> : <>
                                                                        {item.options?.map((opt: any, i: number) => (
                                                                            <div className={`col-md-6 fs-15 d-flex px-0 `} key={i}>
                                                                                <div className={`p-2 w-100 mb-2 ${opt.answer_option ? 'text-success fw-bold' : 'text-gray'}`}>
                                                                                    <span className={`option-name fw-bold ${opt.answer_option ? 'text-success' : 'text-gray'}`}>
                                                                                        {String.fromCharCode(i + 65)}
                                                                                    </span>
                                                                                    <span className="ms-2 option"> {opt?.option_image ? <Image src={window.origin+"/api" + opt.option_image} height={50} /> : opt.option_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        ))}</>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        }))}
                                </div>
                            )}
                        </div>
                        <div className="row mx-0 my-3">

                            <h6 className="ps-0 col-auto me-auto text-dark my-auto">
                                Currently <span className="text-primary fw-bold">{selectedVal?.length || 0}</span> Question(s) in Total and
                                <span className="text-primary fw-bold"> {selectedMark || selectedVal?.length || 0}</span> point(s) in total.
                            </h6>

                            <div className="col-auto ms-auto d-flex pe-0">
                                {isEmptyVal && <div className="text-danger me-2 my-auto">Select minimum of 10 questions in total</div>}
                                <Button className="rounded-0 text-white time-btn ms-auto border-0" type="primary" loading={loading1} onClick={submitPaper}>
                                    Save
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Spin>
            <Modal title={modalTitle} open={isModalOpen} onCancel={handleCancel} onOk={() => addQuestionData()} width={1200}>
                <div className="d-flex">
                    <div className="col my-auto">
                        <h6 className="text-primary fw-bold my-auto">List of Questions</h6>
                    </div>
                    <div className="border ms-auto my-auto me-2 bg-lightOrange text-secondary p-1 rounded">
                        <span className='fw-bold'>Selected Questions: {selectedVal1?.length || 0}</span>
                    </div>

                </div>
                {preferredField == "core|it" ?
                    <div className="mt-3 modal-core-it">
                        <Radio.Group optionType="button" defaultValue={fieldType} value={fieldType}
                            onChange={handleFieldChange}
                            options={[
                                { value: 'core', label: 'Core' },
                                { value: 'it', label: 'IT' },
                            ]}
                        />
                    </div> : ""}
                <div className="d-flex mt-3 mb-2">
                    <div className="col-auto my-auto">
                        {fieldType == "it" ? <Checkbox
                            checked={modalData1.length > 0 && modalData1.every((item: any) => selectedVal1.includes(item.id))}
                            indeterminate={modalData1.some((item: any) => selectedVal1.includes(item.id)) &&
                                !modalData1.every((item: any) => selectedVal1.includes(item.id))}
                            onChange={(e) => handleSelectAll(e.target.checked)}
                        >
                            Select All
                        </Checkbox> :
                            <Checkbox
                                checked={modalData.length > 0 && modalData.every((item: any) => selectedVal1.includes(item.id))}
                                indeterminate={modalData.some((item: any) => selectedVal1.includes(item.id)) &&
                                    !modalData.every((item: any) => selectedVal1.includes(item.id))}
                                onChange={(e) => handleSelectAll(e.target.checked)}
                            >
                                Select All
                            </Checkbox>}
                    </div>
                    <div className="col-md-2 ms-auto pe-1">
                        <Select className="w-100" defaultValue={selectedLevel} value={selectedLevel}
                            onChange={handleChangeLevel}
                            options={[
                                { value: "all", label: "All" },
                                { value: "easy", label: "Easy" },
                                { value: "medium", label: "Medium" },
                                { value: "hard", label: "Hard" }
                            ]} />
                    </div>
                    <div className="col-md-2 pe-1">
                        <Select className="w-100" defaultValue={selectedSubj} value={selectedSubj}
                            onChange={handleChangeSubj}
                            options={subjOptions} loading={loading6}
                            notFoundContent={
                                <div className="text-center p-4">
                                    {loading6 ? (
                                        <span>
                                            <LoadingOutlined />
                                            Loading...
                                        </span>
                                    ) : (
                                        <span>No subject found</span>
                                    )}
                                </div>
                            }
                            filterOption={(input: any, option: any) => (option?.label ?? '')?.toLowerCase().includes(input.toLowerCase())}
                        />
                    </div>
                    <Input
                        className="col-md-3"
                        prefix={<SearchOutlined />}
                        value={searchVal}
                        onChange={(e) => setSearchVal(e.target.value)}
                        onKeyDown={(e) => handleSearch(e)}
                        onKeyUp={(e) => resetSearch(e)}
                        placeholder="Search" />

                </div>
                {preferredField == "core|it" && fieldType == "it" ? <>
                    <div className="mb-3 p-2 bg-light question-list-cont-modal custom-scrollbar row mx-0 overflow-auto">
                        {loading9 ? (
                            <Skeleton active />
                        ) : (
                            <>
                                {modalData1.map((item: any, index: number) => {
                                    counter1++;
                                    return (
                                        <div key={index} className=" d-flex mb-3 col-md-6">
                                            <Checkbox
                                                className="mb-auto"
                                                defaultChecked={selectedVal1?.includes(item.id)}
                                                checked={selectedVal1?.includes(item.id)}
                                                onChange={handleCheckedModal(item.id, item)}
                                            ></Checkbox>
                                            <div className="question-cntr border ms-2 w-100">
                                                <div className="bg-lightPrimary d-flex p-2 align-items-start">
                                                    <div>
                                                        <span className="text-secondary fw-bold pe-3">( {counter1} )</span>
                                                        <span className="author-name fw-bold text-gray pe-4">{item.Mdquestions_name}</span>{' '}
                                                        {item.question_image ? <Image src={window.origin+"/api" + item.question_image} height={50} /> : ""}
                                                        {/* <span className="text-dark">System Admin</span> */}
                                                        <div className="me-2">
                                                            <div className="bg-primary fs-12 text-white rounded px-2 me-2 py-1 col-auto d-inline-block my-2">
                                                                {item.subject}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div className="ms-5 text-dark">
                                                    <span className=" fw-bold text-gray">Updated on: </span> <span className="text-dark">{date.format('DD-MM-YYYY HH:mm')}</span>
                                                </div> */}
                                                    <div className="ms-auto d-flex qus-opr">
                                                        <div className="pe-1 my-auto">
                                                            <DownCircleFilled
                                                                className={`${item.level_of_difficulty == 'easy' ? 'text-success bg-success' : item.level_of_difficulty == 'medium' ? 'text-warning bg-warning' : 'text-danger bg-danger'} rounded-circle`}
                                                            />
                                                        </div>
                                                        <div className="text-primary ms-1 mb-0 mt-1 pointer my-auto" onClick={() => handleExpand(item.id)}>
                                                            {expandVal?.includes(item.id) ? <DownSquareOutlined className="fs-17" rotate={-90} /> : <DownSquareOutlined className="fs-17" />}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`p-2 d-flex question-contn bg-white ${expandVal?.includes(item.id) ? 'incheight' : ''}`}>
                                                    <div className="ps-2 pe-4 w-100">
                                                        {/* <span className="question text-dark fs-16">{item.Mdquestions_name}</span> */}
                                                        <div className="row m-3">
                                                            {item.Mdquestions_type === "inputfield" || item.Mdquestions_type == "input" ? <div className="fw-bold fs-15">
                                                                <span className="text-success">
                                                                    {item.answer}
                                                                </span>
                                                            </div> : <>
                                                                {item.options?.map((opt: any, i: number) => {
                                                                    return (
                                                                        <div className={`col-md-6 d-flex ${i % 2 == 0 ? 'ps-0' : 'pe-0'}`} key={i}>
                                                                            <div className={`p-2 w-100 mb-2 fs-15 ${opt.answer_option ? 'text-success fw-bold' : 'text-gray '}`}>
                                                                                <span className={`option-name fw-bold ${opt.answer_option ? 'text-success' : 'text-gray '}`}>
                                                                                    {String.fromCharCode(i + 65)}
                                                                                </span>
                                                                                <span className="ms-2 option"> {opt?.option_image ? <Image src={window.origin+"/api" + opt.option_image} height={50} /> : opt.option_name}</span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}</>}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                    <div className="text-center">
                        <Pagination defaultCurrent={itPageIndex} current={itPageIndex} total={itTotalPage} defaultPageSize={itPageSize} pageSize={itPageSize}
                            onChange={handleChangePagination1}
                            onShowSizeChange={handlePageSizeChange1} showTotal={(total) => `Total ${count} items`} />
                    </div></> : <>
                    <div className="mb-3 p-2 bg-light question-list-cont-modal custom-scrollbar row mx-0 overflow-auto">
                        {paperLoading ? (
                            <Skeleton active />
                        ) : (
                            <>
                                {modalData.map((item: any, index: number) => {
                                    counter1++;
                                    return (
                                        <div key={index} className=" d-flex mb-3 col-md-6">
                                            <Checkbox
                                                className="mb-auto"
                                                defaultChecked={selectedVal1?.includes(item.id)}
                                                checked={selectedVal1?.includes(item.id)}
                                                onChange={handleCheckedModal(item.id, item)}
                                            ></Checkbox>
                                            <div className="question-cntr border ms-2 w-100">
                                                <div className="bg-lightPrimary d-flex p-2 align-items-start">
                                                    <div>
                                                        <span className="text-secondary fw-bold pe-3">( {counter1} )</span>
                                                        <span className="author-name fw-bold text-gray pe-4">{item.Mdquestions_name}</span>{' '}
                                                        {item.question_image ? <Image src={window.origin+"/api"+ item.question_image} height={50} /> : ""}
                                                        {/* <span className="text-dark">System Admin</span> */}
                                                        <div className="me-2">
                                                            <div className="bg-primary fs-12 text-white rounded px-2 me-2 py-1 col-auto d-inline-block my-2">
                                                                {item.subject}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* <div className="ms-5 text-dark">
                                                    <span className=" fw-bold text-gray">Updated on: </span> <span className="text-dark">{date.format('DD-MM-YYYY HH:mm')}</span>
                                                </div> */}
                                                    <div className="ms-auto d-flex qus-opr">
                                                        <div className="pe-1 my-auto">
                                                            <DownCircleFilled
                                                                className={`${item.level_of_difficulty == 'easy' ? 'text-success bg-success' : item.level_of_difficulty == 'medium' ? 'text-warning bg-warning' : 'text-danger bg-danger'} rounded-circle`}
                                                            />
                                                        </div>
                                                        <div className="text-primary ms-1 mb-0 mt-1 pointer my-auto" onClick={() => handleExpand(item.id)}>
                                                            {expandVal?.includes(item.id) ? <DownSquareOutlined className="fs-17" rotate={-90} /> : <DownSquareOutlined className="fs-17" />}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={`p-2 d-flex question-contn bg-white ${expandVal?.includes(item.id) ? 'incheight' : ''}`}>
                                                    <div className="ps-2 pe-4 w-100">
                                                        {/* <span className="question text-dark fs-16">{item.Mdquestions_name}</span> */}
                                                        <div className="row m-3">
                                                            {item.Mdquestions_type === "inputfield" || item.Mdquestions_type == "input" ? <div className="fw-bold fs-15">
                                                                <span className="text-success">
                                                                    {item.answer}
                                                                </span>
                                                            </div> : <>
                                                                {item.options?.map((opt: any, i: number) => {
                                                                    return (
                                                                        <div className={`col-md-6 d-flex ${i % 2 == 0 ? 'ps-0' : 'pe-0'}`} key={i}>
                                                                            <div className={`p-2 w-100 mb-2 fs-15 ${opt.answer_option ? 'text-success fw-bold' : 'text-gray '}`}>
                                                                                <span className={`option-name fw-bold ${opt.answer_option ? 'text-success' : 'text-gray '}`}>
                                                                                    {String.fromCharCode(i + 65)}
                                                                                </span>
                                                                                <span className="ms-2 option"> {opt?.option_image ? <Image src={window.origin+"/api" + opt.option_image} height={50} /> : opt.option_name}</span>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}</>}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </>
                        )}
                    </div>
                    <div className="text-center">
                        <Pagination defaultCurrent={pageIndex} current={pageIndex} total={totalRecord} defaultPageSize={pageSize} pageSize={pageSize}
                            onChange={handleChangePagination}
                            onShowSizeChange={handlePageSizeChange} showTotal={(total) => `Total ${count} items`} />
                    </div>
                </>}
            </Modal>
        </div>
    );
};

export default UpdateQuestionPaper;
